t = require('views/internal/teacup-with-helpers')('confirm')

module.exports = ->
  t.p ->
    if t.mustacheVar('html')
      t.raw t.mustacheVar('html')
    else
      t.text t.mustacheVar('text')

  t.input '.js-confirm.full', { type: 'submit', class: t.mustacheVar('confirmBtnClass'), value: t.mustacheVar('confirmText') }

  t.mustacheBlock 'cancelText', ->
    t.input '.js-cancel.full', { type: 'submit', value: t.mustacheVar('cancelText') }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/confirm.coffee